import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation} from '@angular/core';
import {FoldDetailService} from '../../../../../services/apiServices/business/fold-detail.service';
import {TranslateService} from '@ngx-translate/core';
import {RowStatus} from '../../../../../model/row-status';
import {CustomDate} from '../../../../../model/custom-date';
import {MenuItem} from 'primeng/api';
import {ApiConst} from '../../../../../services/apiServices/api-const';
import {HttpService} from '../../../../../services/apiServices/http-service.service';
import {BROWSERS, DeviceDetectorService, DeviceInfo} from 'ngx-device-detector';
import {AuthenticationService} from '../../../../../services/apiServices/security/authentication.service';
import {User} from '../../../../../model/user';
import {ActionConfirmKind} from '../../../../../model/action-confirm-kind';
import {FileSaverService} from 'ngx-filesaver';
import {CommonService} from '../../../../../services/apiServices/business/common.service';
import {switchMap} from "rxjs/operators";
import {from} from "rxjs";

/**
 * represent and handle the list of actions attached to a fold
 */
@Component({
  selector: 'app-fold-action',
  templateUrl: './fold-action.component.html',
  styleUrls: ['./fold-action.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FoldActionComponent implements OnInit, OnChanges {
  private deviceInfo: DeviceInfo;

  /**
   * the fold for which the actions will be displayed and handled
   */
  @Input('fold') public fold: any;

  currentUser: User;

  /**
   * if the user click on Deposit button
   */
  public openDeposit: boolean;
  public enableActions: boolean;

  /**
   * if the user click on Treatment button
   */
  public openTreatment: boolean;

  /**
   * if the user click on Visualization button
   */
  public openVisualization: boolean;
  /**
   * should use the native viewer or some exetrenal libs (native is not working with ie)
   */
  public msBrowsers: boolean;
  /**
   * If the user click on visualization or exclude
   */
  public openConfirmOrExclude: boolean;

  /**
   * If the user click on Adress
   */
  public openAdress: boolean;

  /**
   * list of deposits columns (not dynamic)
   */
  public depositColumns;

  /**
   * list of treatments columns (not dynamic)
   */
  public treatmentColumns;
  public erlTreatmentColumns;

  /**
   * list of datas that represent the list of treatments or deposits
   */
  public datas: any[];

  /**
   * the date column header, here for translation purposes
   */
  private dateColumnHeader: string;

  /**
   * the fileName column header, here for translation purpose
   */
  private fileNameColumnHeader: string;

  /**
   * the kind of deposit type column header, here for translation purpose
   */
  private kindColumnHeader: string;

  /**
   * the index column header, here for translation purpose
   */
  private indexColumnHeader: string;

  /**
   * the status column header, here for translation purpose
   */
  private detailColumnHeader: string;

  /**
   * the status column header, here for translation purpose
   */
  private statusColumnHeader: string;
  private statusMessageColumnHeader: string;
  private statusUserColumnHeader: string;

  /**
   * the status column header, here for translation purpose
   */
  private fileVersionColumnHeader: string;

  /**
   * the pdf that would be display if the user click on visualization
   */
  public pdfToDisplay: any;

  /**
   * pdf viewer choices
   */
  public items: MenuItem[];
  /**
   * the user choice inside ActionConfirmKind
   */
  public userChoiceOfAction: number;

  /**
   * the file download button label
   */
  private downloadButtonLabel: string;

  /**
   * open file in new tab button label
   */
  private openInNewTabButtonLabel: string;
  /**
   * download archive button label
   */
  private archiveButtonLabel: string;
  /**
   * visu archive button label
   */
  private visuArchiveButtonLabel: string;

  /**
   * download archive button label
   */
  private downloadARButtonLabel: string;
  /**
   * visu archive button label
   */
  private visuARButtonLabel: string;

  /**
   * download archive button label
   */
  private downloadPNDButtonLabel: string;
  /**
   * visu archive button label
   */
  private visuPNDButtonLabel: string;
  /**
   * Archive not found message
   */
  statuslabels: any;
  private archiveNotFoundMsg: string;
  public showProcessingDetailBtn: boolean;
  constructor(private httpService: HttpService, private foldDetailService: FoldDetailService,
              private fileSaverService: FileSaverService,
              private translate: TranslateService, private commonService: CommonService,
              private deviceService: DeviceDetectorService, private authService: AuthenticationService) {
  }

  /**
   * build fixed deposits columns
   */
  private buildDepositColumns(): void {
    this.depositColumns = [];
    this.depositColumns.push({field: 'sDptType', header: this.kindColumnHeader, width: '5%'});
    this.depositColumns.push({field: 'dDepotDateTime', header: this.dateColumnHeader, width: '17%'});
    this.depositColumns.push({field: 'sFileName', header: this.fileNameColumnHeader, width: '68%'});
  }

  /**
   * build fixed treatments columns
   */
  private buildTreatmentColumns(): void {
    this.treatmentColumns = [];
    this.treatmentColumns.push({field: 'sIndice', header: this.indexColumnHeader, width: '6%'});
    this.treatmentColumns.push({field: 'sTrtDateTime', header: this.dateColumnHeader, width: '17%'});
    this.treatmentColumns.push({field: 'sTrtChainName', header: this.detailColumnHeader, width: '55%'});
    this.treatmentColumns.push({field: 'sReturnCode', header: this.statusColumnHeader, width: '7%'});
    this.treatmentColumns.push({field: 'sFileNameIndice', header: this.fileVersionColumnHeader, width: '8%'});
    this.erlTreatmentColumns = [];
    this.erlTreatmentColumns.push({field: 'date', header: this.dateColumnHeader, width: '15%'});
    this.erlTreatmentColumns.push({field: 'details', header: this.statusMessageColumnHeader, width: '55%'});
    this.erlTreatmentColumns.push({field: 'status', header: this.statusColumnHeader, width: '15%'});
    this.erlTreatmentColumns.push({field: 'userId', header: this.statusUserColumnHeader, width: '15%'});
  }

  /**
   * obtain translation from TranslateService
   */
  private getTradForComponent(): void {
    // DEPOSIT COLUMNS TRAD
    this.translate.get('FOLD.ACTION_COMPONENT.DEPOSIT.KIND').subscribe((answer: string) => {
      this.kindColumnHeader = answer;
    });
    this.translate.get('FOLD.ACTION_COMPONENT.DEPOSIT.FILENAME').subscribe((answer: string) => {
      this.fileNameColumnHeader = answer;
    });

    // COMMONS
    this.translate.get('FOLD.ACTION_COMPONENT.DATE').subscribe((answer: string) => {
      this.dateColumnHeader = answer;
    });

    // TREATMENTS COLUMNS TRAD
    this.translate.get('FOLD.ACTION_COMPONENT.TREATMENT.INDEX').subscribe((answer: string) => {
      this.indexColumnHeader = answer;
    });
    this.translate.get('FOLD.ACTION_COMPONENT.TREATMENT.DETAIL').subscribe((answer: string) => {
      this.detailColumnHeader = answer;
    });
    this.translate.get('FOLD.ACTION_COMPONENT.TREATMENT.STATUS').subscribe((answer: string) => {
      this.statusColumnHeader = answer;
    });
    this.translate.get('FOLD.ACTION_COMPONENT.TREATMENT.STATUS_USER').subscribe((answer: string) => {
      this.statusUserColumnHeader = answer;
    });
    this.translate.get('FOLD.ACTION_COMPONENT.TREATMENT.STATUS_MESSAGE').subscribe((answer: string) => {
      this.statusMessageColumnHeader = answer;
    });
    this.translate.get('FOLD.ACTION_COMPONENT.TREATMENT.VERSION').subscribe((answer: string) => {
      this.fileVersionColumnHeader = answer;
    });
    this.translate.get('FOLD.ACTION_COMPONENT.VISU_DOCUMENT_EXT_BUTTON').subscribe((answer: string) => {
      this.downloadButtonLabel = answer;
    });
    this.translate.get('FOLD.ACTION_COMPONENT.VISU_DOCUMENT_TAB_BUTTON').subscribe((answer: string) => {
      this.openInNewTabButtonLabel = answer;
    });
    this.translate.get('FOLD.ACTION_COMPONENT.VISU_DOCUMENT_ARCH_BUTTON').subscribe((answer: string) => {
      this.archiveButtonLabel = answer;
    });
    this.translate.get('FOLD.ACTION_COMPONENT.VISU_DOCUMENT_VISU_ARCH_BUTTON').subscribe((answer: string) => {
      this.visuArchiveButtonLabel = answer;
    });
    this.translate.get('FOLD.ACTION_COMPONENT.DL_AR_BUTTON').subscribe((answer: string) => {
      this.downloadARButtonLabel = answer;
    });
    this.translate.get('FOLD.ACTION_COMPONENT.VISU_AR_BUTTON').subscribe((answer: string) => {
      this.visuARButtonLabel = answer;
    });
    this.translate.get('FOLD.ACTION_COMPONENT.DL_PND_BUTTON').subscribe((answer: string) => {
      this.downloadPNDButtonLabel = answer;
    });
    this.translate.get('FOLD.ACTION_COMPONENT.VISU_PND_BUTTON').subscribe((answer: string) => {
      this.visuPNDButtonLabel = answer;
    });
    this.translate.get('FOLD.ACTION_COMPONENT.VISU_DOCUMENT_ARCH_NOT_FOUND').subscribe((answer: string) => {
      this.archiveNotFoundMsg = answer;
    });
    this.statuslabels = {
      'DONE': 'Effectué',
      'RESTORE': 'Relancé',
      'DISMISSED': 'Ecarté',
      'CANCEL_PLAN': 'Plan. annulée',
      'PLAN': 'planifié',
      'OK': 'Exécuté',
      'NE': 'Non executé',
      'toProcess': 'A traiter'
    };
    this.translate.get('COMMON.TRT_STATUS.DISMISSED').subscribe((answer: string) => {
      this.statuslabels['DISMISSED'] = answer;
    });
    this.translate.get('COMMON.TRT_STATUS.CANCEL_PLAN').subscribe((answer: string) => {
      this.statuslabels['CANCEL_PLAN'] = answer;
    });
    this.translate.get('COMMON.TRT_STATUS.PLAN').subscribe((answer: string) => {
      this.statuslabels['PLAN'] = answer;
    });
    this.translate.get('COMMON.TRT_STATUS.OK').subscribe((answer: string) => {
      this.statuslabels['OK'] = answer;
    });
    this.translate.get('COMMON.TRT_STATUS.NE').subscribe((answer: string) => {
      this.statuslabels['NE'] = answer;
    });
    this.translate.get('COMMON.TRT_STATUS.toProcess').subscribe((answer: string) => {
      this.statuslabels['toProcess'] = answer;
    });

  }

  /**
   * handle traduction, and column build
   */
  public ngOnInit(): void {
    this.currentUser = this.authService.getCurrentUser();
    this.enableActions = this.currentUser.permissions.trackingDepot.withAction;
    this.showProcessingDetailBtn = false;
    this.showProcessingDetailBtn = this.currentUser.admin === true || this.currentUser.supervisor === true;
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.msBrowsers = (BROWSERS.IE === this.deviceInfo.browser || BROWSERS.MS_EDGE === this.deviceInfo.browser);
    this.openDeposit = false;
    this.openTreatment = false;
    this.openConfirmOrExclude = false;
    this.openAdress = false;
    this.openVisualization = false;
    this.getTradForComponent();
    this.buildDepositColumns();
    this.buildTreatmentColumns();
    this.initVisuButtons();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    console.log("ngOnChanges");
    if (changes['fold'].currentValue != changes['fold'].previousValue) {
      this.initVisuButtons();
    }
  }


  private getFileContentBySerialFromProtectedUrl(serialSent: string): void {
    this.httpService.$get(ApiConst.getFileContentBySerial, { serialSent })
      .subscribe({
        next: (response) => {
          const blob = response.body;
          const blobUrl = URL.createObjectURL(blob);

          window.open(blobUrl, '_blank');

          setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
        },
        error: err => console.error('Erreur affichage PDF', err)
      });
  }

  private getArchContentBySerialFromProtectedUrl(serialSent: string): void {
    this.httpService.$get(ApiConst.getArchContentBySerial, { serialSent })
      .subscribe({
        next: (response) => {
          const blob = response.body;
          const blobUrl = URL.createObjectURL(blob);

          window.open(blobUrl, '_blank');

          setTimeout(() => URL.revokeObjectURL(blobUrl), 60000);
        },
        error: err => console.error('Erreur affichage PDF', err)
      });
  }


  public initVisuButtons(): void {
    this.items = [
      {
        label: this.downloadButtonLabel,
        icon: 'fa fa-download',
        command: () => {
          this.downloadVisu();
        }
      }
    ];
    if (!this.msBrowsers) {
      this.items.push({
        label: this.openInNewTabButtonLabel,
        icon: 'fa fa-window-restore',
        command: () => {
          this.externVisu();
        }
      });
    }
    if (this.fold.dCfeArchiveDate) {
      this.items.push({
        label: this.visuArchiveButtonLabel,
        icon: 'fa fa-eye',
        command: () => {
          this.visuArchive();
        }
      });

      this.items.push({
        label: this.archiveButtonLabel,
        icon: 'fa fa-archive',
        command: () => {
          this.downloadArch();
        }
      });
      if(this.fold.sSentARDate){
        this.items.push({
          label: this.visuARButtonLabel,
          icon: 'fa fa-eye',
          command: () => {
            this.visuAR();
          }
        });

        this.items.push({
          label: this.downloadARButtonLabel,
          icon: 'fa fa-archive',
          command: () => {
            this.downloadAR();
          }
        });
      }

      if(this.fold.sFormatedDatepnd){
        this.items.push({
          label: this.visuPNDButtonLabel,
          icon: 'fa fa-eye',
          command: () => {
            this.visuPND();
          }
        });

        this.items.push({
          label: this.downloadPNDButtonLabel,
          icon: 'fa fa-archive',
          command: () => {
            this.downloadPND();
          }
        });
      }

    }
  }

  /**
   * load deposits detail for a fold
   * /_!_\ Specific to deposits: date gave by back need to be formatted
   */
  public loadDeposit(): void {
    const serialLotDepot = this.fold.lSerialLotDepot || this.fold.serialLotDepot;

    this.foldDetailService.getDeposit( serialLotDepot ).subscribe(response => {
      const res = response.body.listObjDepotFile;
      if (res) {
        for (const e of res) {
          e.dDepotDateTime = CustomDate.getFormatedDateFromNumber(e.dDepotDateTime);
        }
        this.datas = res;
      }
      this.openDeposit = true;
    });
  }

  /**
   * load treatments detail for a fold
   */
  public loadTreatment(): void {
    if (this.fold.erlId) {
      this.foldDetailService.getErlTrackingList(this.fold.erlId).subscribe(res => {
        if (res.cledErlhistorList) {
          this.datas = res.cledErlhistorList;
        }
        this.openTreatment = true;
      });
    }
    else if (this.fold.serialSent && this.fold.serialSent !== '0') {
      this.foldDetailService.getTreatment(this.fold.serialSent).subscribe(res => {
        if (res.listObjTrackingTrt) {
          this.datas = res.listObjTrackingTrt;
          for (const entry of this.datas) {
            if (this.statuslabels.hasOwnProperty(entry.sReturnCode)) {
              entry.sReturnCode = this.statuslabels[entry.sReturnCode];
            }
          }
        }
        this.openTreatment = true;
      });
    }
  }

 public hasTreatement(): boolean {
    return (this.fold.serialSent !== '0');
 }

  /**
   * load Visualization for a fold
   */
  public loadVisu(): void {
    if (this.msBrowsers) {
      if (this.fold.serialSent) {
        this.pdfToDisplay = ApiConst.apiUrl + '/getFileContentBySerial/' + this.fold.serialSent;
        this.getFileContentBySerialFromProtectedUrl(this.fold.serialSent);
        // this.openVisualization = true;
      }
    }
    else {
      if (this.fold.sFileName && this.fold.sFilePath) {
        this.foldDetailService.getFileContent(this.fold.sFileName, this.fold.sFilePath, "ALL").subscribe(response => {
          const typeOfReponse = response.headers.get('content-type');
          if (typeOfReponse && typeOfReponse.includes('pdf')) {
            const blob = new Blob([ response.body ], {type: response.headers.get('content-type')});
            this.pdfToDisplay = window.URL.createObjectURL(blob);
            this.openVisualization = true;
          }
        });
      }
      else if (this.fold.serialSent) {
        this.foldDetailService.getFileContentBySerialSent(this.fold.serialSent).subscribe(response => {
          const typeOfReponse = response.headers.get('content-type');
          if (typeOfReponse && typeOfReponse.includes('pdf')) {
            const blob = new Blob([ response.body ], {type: response.headers.get('content-type')});
            this.pdfToDisplay = window.URL.createObjectURL(blob);
            this.openVisualization = true;
          }
        });
      }
    }
  }
  public externVisu(): void {
      if (this.fold.serialSent) {
        this.pdfToDisplay = ApiConst.apiUrl + '/getFileContentBySerial/' + this.fold.serialSent;
        this.getFileContentBySerialFromProtectedUrl(this.fold.serialSent);
        // this.openVisualization = true;
      }

/*
    if (this.fold.sFileName && this.fold.sFilePath) {
      this.foldDetailService.getFileContent(this.fold.sFileName, this.fold.sFilePath).subscribe(response => {
        const typeOfReponse = response.headers.get('content-type');
        if (typeOfReponse && typeOfReponse.includes('pdf')) {
          const fileBlob = response.blob();
          const blob = new Blob([fileBlob], {type: response.headers.get('content-type')});
          this.pdfToDisplay = window.URL.createObjectURL(blob);
          window.open(this.pdfToDisplay);
        }
      });
    }
    */
  }
  public downloadVisu(): void {
    if (this.fold.sFileName && this.fold.sFilePath) {
      this.foldDetailService.downloadFileContent(this.fold.sFileName, this.fold.sFilePath, "ALL").subscribe(response => {
        const typeOfReponse = response.headers.get('content-type');
        if (typeOfReponse && !typeOfReponse.includes('application/json')) {
          const blob = new Blob([ response.body ], {type: response.headers.get('content-type')});
          this.fileSaverService.save(blob, this.fold.sFileName);
        }
      });
    }
    else if (this.fold.serialSent)  {
      this.foldDetailService.downloadFileContentBySerialSent(this.fold.serialSent).subscribe(response => {
        const typeOfReponse = response.headers.get('content-type');
        if (typeOfReponse && !typeOfReponse.includes('application/json')) {
          const blob = new Blob([ response.body ], {type: response.headers.get('content-type')});
          this.fileSaverService.save(blob, this.fold.sFileName);
        }
      });
    }
  }
  public downloadArch(): void {
    if (this.fold.sFileName && this.fold.sFilePath) {
      this.foldDetailService.downloadFileContent('CFE', this.fold.serialSent, "ALL").subscribe(response => {
        const typeOfReponse = response.headers.get('content-type');
        if (typeOfReponse && !typeOfReponse.includes('application/json')) {
          if (response.body.size > 0) {
            const blob = new Blob([ response.body ], {type: response.headers.get('content-type')});
            this.fileSaverService.save(blob, this.fold.sFileName);
          }
          else {
            this.commonService.addToast({
              life: 3000,
              severity: 'error',
              summary: 'Archive',
              detail: this.archiveNotFoundMsg
            });
          }
        }
      });
    }
  }
  public visuArchive(): void {
    if (this.msBrowsers) {
      this.pdfToDisplay = ApiConst.apiUrl + '/getArchContentBySerial/' + this.fold.serialSent;
      this.getArchContentBySerialFromProtectedUrl(this.fold.serialSent);
    }
    else {
      this.foldDetailService.getFileContent('CFE', this.fold.serialSent, "ALL").subscribe(response => {
        const typeOfReponse = response.headers.get('content-type');
        if (typeOfReponse && typeOfReponse.includes('pdf')) {
          const blob = new Blob([ response.body ], {type: response.headers.get('content-type')});
          this.pdfToDisplay = window.URL.createObjectURL(blob);
          this.openVisualization = true;
        }
      });
    }
  }

  public downloadAR(): void {
    if (this.fold.sFileName && this.fold.sFilePath) {
      this.foldDetailService.downloadFileContent('CFE', this.fold.serialSent, "AR").subscribe(response => {
        const typeOfReponse = response.headers.get('content-type');
        if (typeOfReponse && !typeOfReponse.includes('application/json')) {
          if (response.body.size > 0) {
            const blob = new Blob([ response.body ], {type: response.headers.get('content-type')});
            this.fileSaverService.save(blob, this.fold.sFileName);
          }
          else {
            this.commonService.addToast({
              life: 3000,
              severity: 'error',
              summary: 'Archive',
              detail: this.archiveNotFoundMsg
            });
          }
        }
      });
    }
  }
  public visuAR(): void {
    if (this.msBrowsers) {
      this.pdfToDisplay = ApiConst.apiUrl + '/getArchContentBySerial/' + this.fold.serialSent;
      this.getArchContentBySerialFromProtectedUrl(this.fold.serialSent);
    }
    else {
      this.foldDetailService.getFileContent('CFE', this.fold.serialSent, "AR").subscribe(response => {
        const typeOfReponse = response.headers.get('content-type');
        if (typeOfReponse && typeOfReponse.includes('pdf')) {
          const blob = new Blob([ response.body ], {type: response.headers.get('content-type')});
          this.pdfToDisplay = window.URL.createObjectURL(blob);
          this.openVisualization = true;
        }
      });
    }
  }


  public downloadPND(): void {
    if (this.fold.sFileName && this.fold.sFilePath) {
      this.foldDetailService.downloadFileContent('CFE', this.fold.serialSent, "PND").subscribe(response => {
        const typeOfReponse = response.headers.get('content-type');
        if (typeOfReponse && !typeOfReponse.includes('application/json')) {
          if (response.body.size > 0) {
            const blob = new Blob([ response.body ], {type: response.headers.get('content-type')});
            this.fileSaverService.save(blob, this.fold.sFileName);
          }
          else {
            this.commonService.addToast({
              life: 3000,
              severity: 'error',
              summary: 'Archive',
              detail: this.archiveNotFoundMsg
            });
          }
        }
      });
    }
  }
  public visuPND(): void {
    if (this.msBrowsers) {
      this.pdfToDisplay = ApiConst.apiUrl + '/getArchContentBySerial/' + this.fold.serialSent;
      this.getArchContentBySerialFromProtectedUrl(this.fold.serialSent);
    }
    else {
      this.foldDetailService.getFileContent('CFE', this.fold.serialSent, "PND").subscribe(response => {
        const typeOfReponse = response.headers.get('content-type');
        if (typeOfReponse && typeOfReponse.includes('pdf')) {
          const blob = new Blob([ response.body ], {type: response.headers.get('content-type')});
          this.pdfToDisplay = window.URL.createObjectURL(blob);
          this.openVisualization = true;
        }
      });
    }
  }


  public isViewable(): boolean {
    return (this.fold.sFileName && this.fold.sFilePath);
  }

  /**
   * free window URL (memory purposes)
   */
  public freeDocMemory(documentToFree): void {
    window.URL.revokeObjectURL(documentToFree);
  }

  /**
   * load Exclusion for a fold
   */
  public loadExclude(): void {
    this.openConfirmOrExclude = true;
    this.userChoiceOfAction = ActionConfirmKind.EXCLUDE;
  }
  public loadPlanFor(): void {
    this.openConfirmOrExclude = true;
    this.userChoiceOfAction = ActionConfirmKind.PLAN;
  }
  public loadCancelPlan(): void {
    this.openConfirmOrExclude = true;
    this.userChoiceOfAction = ActionConfirmKind.CANCEL_PLAN;
  }
  /**
   * load Retry for a fold
   */
  public loadNewRun(): void {
    this.openConfirmOrExclude = true;
    this.userChoiceOfAction = ActionConfirmKind.NEWRUN;
  }

  public loadRestore(): void {
    this.openConfirmOrExclude = true;
    this.userChoiceOfAction = ActionConfirmKind.RESTORE;
  }

  /**
   * load Adress for a fold
   */
  public loadAdress(): void {
    this.openAdress = true;
  }
  public addressable(): boolean {
    if (!this.enableActions) {
      return false;
    }
    if (this.hasTreatement()) {
      if (this.isFoldStatusExported()) {
        return false;
      }
      else {
        return (( this.isFoldStatusDiscard() || this.isFoldStatusFail() || this.isFoldStatusWaiting() || this.isFoldStatusSuccess()));
      }
    }
    else {
      return false;
    }
  }
  /**
   *
   * @param {boolean} result - the result of the event gave by action-confirm
   */
  public handleConfirmOrExcludeModalClose(result: boolean): void {
    this.openConfirmOrExclude = result;
  }

  /**
   *
   * @param {boolean} result - the result of the event gave by finalAddress
   */
  public handleAddressClose(result: boolean): void {
    this.openAdress = result;
  }

  /**
   * determine if the status of the fold is fail
   * @return {boolean}, the result of the comparison
   */
  public isFoldStatusFail(): boolean {
    return (this.fold.rawStatus === RowStatus.FAILED || this.fold.rawStatus === RowStatus.FAILED_LEGACY);
  }
  /**
   * determine if the status of the fold is fail
   * @return {boolean}, the result of the comparison
   */
  public restoreEnabled(): boolean {
    if (!this.enableActions) {
      return false;
    }
    return this.isFoldStatusFail()  || this.isFoldStatusDiscard();
  }

  /**
   * determine if the status of the fold is success
   * @return {boolean}, the result of the comparison
   */
  public isFoldStatusSuccess(): boolean {
    return (this.fold.rawStatus === RowStatus.PROCESSED && !this.fold.sFlowExchID);
  }
  /**
   * determine if the fold can be excluded when is has Success and not yet exported
   * @return {boolean}, the result of the comparison
   */
  public isFoldExcludable(): boolean {
    if (!this.enableActions) {
      return false;
    }
    if (!this.fold.erlId) {
      return (this.isFoldStatusSuccess() && !this.fold.sFlowExchID);
    }
    else {
      return !this.fold.hasBeenExported;
    }
  }
  public isFoldPlannable(): boolean {
    if (!this.enableActions) {
      return false;
    }
    if (!this.fold.erlId) {
      return (this.isFoldStatusSuccess() && !this.fold.sFlowExchID && !this.fold.delayedsenddate);
    }
    else {
      return false;
    }
  }
  public isFoldPlanned(): boolean {
    if (!this.fold.erlId) {
      return (this.isFoldStatusSuccess() && !this.fold.sFlowExchID && this.fold.delayedsenddate);
    }
    else {
      return false;
    }
  }

  public isFoldStatusExported(): boolean {
    return this.fold.sFlowExchID && this.fold.sFlowExchID.length !== 0;

  }

  /**
   * determine if the status of the fold is discard
   * @return {boolean}, the result of the comparison
   */
  public isFoldStatusDiscard(): boolean {
    return (this.fold.rawStatus === RowStatus.DISCARDED || this.fold.rawStatus === RowStatus.DISCARDED_LEGACY);
  }

  /**
   * determine if the status of the fold is discard
   * @return {boolean}, the result of the comparison
   */
  public isFoldStatusWaiting(): boolean {
    return (this.fold.rawStatus === RowStatus.WAITING);
  }

  public update(): void {
    if (this.fold.erlId) {
      this.foldDetailService.getErlTrackingList(this.fold.erlId).subscribe(res => {
        if (res.cledErlhistorList) {
          this.datas = res.cledErlhistorList;
        }
      });
    }
    else if (this.fold.serialSent && this.fold.serialSent !== '0') {
      this.foldDetailService.getTreatment(this.fold.serialSent).subscribe(res => {
        if (res.listObjTrackingTrt) {
          this.datas = res.listObjTrackingTrt;
          for (const entry of this.datas) {
            if (this.statuslabels.hasOwnProperty(entry.sReturnCode)) {
              entry.sReturnCode = this.statuslabels[entry.sReturnCode];
            }
          }
        }
      });
    }
  }

  public close(): void {
    this.openTreatment = false;
  }
}
